<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
    <a class="navbar-brand js-scroll-trigger" href="#page-top">
        <span class="d-block d-lg-none">{{ firstName }} {{ lastName }}</span>
        <span class="d-none d-lg-block">
          <img class="img-fluid img-profile rounded-circle mx-auto mb-2"
               src="../assets/img/profile.jpg"
               alt="..." />
          </span>
    </a>
    <button class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#about">{{ about }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#experience">{{ experience }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#skills">{{ skills }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#interests">{{ interests }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#education">{{ education }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#contact">{{ contact }}</a>
        </li>
        <li class="nav-item">
          <button @click="toggleTheme()" class="btn theme-toggle" :title="themeToggleTitle">
            <i :class="themeIcon" class="fa-2x"></i>
          </button>
        </li>
        <li class="nav-item">
          <button @click="changeLanguage()" class="btn">
            <i class="fas fa-language fa-2x lang-btn"></i>
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  methods: {
    changeLanguage() {
      const languages = ['en', 'zh'];
      const currentLanguage = this.$i18n.locale;
      const index = languages.indexOf(currentLanguage);
      const nextIndex = (index + 1) % languages.length;
      this.$i18n.locale = languages[nextIndex];
    },
    toggleTheme() {
      const currentTheme = document.documentElement.getAttribute('data-theme');
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', newTheme);
      localStorage.setItem('theme', newTheme);
    }
  },
  computed: {
    firstName() {
      return this.$t('profile.firstName');
    },
    lastName() {
      return this.$t('profile.lastName');
    },
    about() {
      return this.$t('sections.about')
    },
    education() {
      return this.$t('sections.education')
    },
    experience() {
      return this.$t('sections.experience')
    },
    skills() {
      return this.$t('sections.skills')
    },
    interests() {
      return this.$t('sections.interests')
    },
    contact() {
      return this.$t('sections.contact')
    },
    themeIcon() {
      const currentTheme = document.documentElement.getAttribute('data-theme');
      return currentTheme === 'dark' ? 'fas fa-sun' : 'fas fa-moon';
    },
    themeToggleTitle() {
      const currentTheme = document.documentElement.getAttribute('data-theme');
      return currentTheme === 'dark' ? this.$t('theme.toggleLight') : this.$t('theme.toggleDark');
    }
  }
};
</script>

<style scoped>

.lang-btn {
  background-color: transparent;
  border: none;
  color: var(--bs-nav-link-color);
}

</style>